module.exports = __webpack_public_path__ + "img/account-sets-blue.f281e91d.svg";